/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B010040 受注チェックリスト
 */
import {
  B010040GetExcel,
  B010040Request,
  B000120EigyoNmFrom,
  B000120EigyoNmTo,
  B000130BumonNmFrom,
  B000130BumonNmTo,
  B000140ShainNmFrom,
  B000140ShainNmTo,
  B000150TokuiNmFrom,
  B000150TokuiNmTo,
  B000140AssistantNm,
  catchFileError,
} from "clients/rest";
import {
  SText,
  SCodeSelect,
  SDateField,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  STextField,
  msgState,
} from "components";
import {
  ShokaKbn,
  B010040Sort,
  getSCode,
  SCode,
  B010040Status,
} from "messages/codes";
import { labels } from "messages/labels";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, useFocus } from "states";
import { date, download, startOfMonth } from "services";
import { useNavigate } from "react-router-dom";
import { B000130, B000140, B000150, B000202 } from "pages";
import { B000120 } from "pages/b000/B000120";
import { shokaKbn } from "services/codes";
import { getClientMessage } from "messages";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  eigyoCdFrom: string;
  eigyoNmFrom: string;
  eigyoCdTo: string;
  eigyoNmTo: string;
  bumonCdFrom: string;
  bumonNmFrom: string;
  bumonCdTo: string;
  bumonNmTo: string;
  shainCdFrom: string;
  shainNmFrom: string;
  shainCdTo: string;
  shainNmTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiNmFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  tokuiNmTo: string;
  shokaKbn: SCode;
  sort1: SCode;
  sort2: SCode;
  sort3: SCode;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  hasoYmdFrom: string;
  hasoYmdTo: string;
  b010040Status: SCode;
  assistantCd: string;
  assistantNm: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  juchuYmdFrom: startOfMonth(date()),
  juchuYmdTo: date(),
  seisakuYmdFrom: startOfMonth(date()),
  seisakuYmdTo: date(),
  eigyoCdFrom: "",
  eigyoNmFrom: "",
  eigyoCdTo: "",
  eigyoNmTo: "",
  bumonCdFrom: "",
  bumonNmFrom: "",
  bumonCdTo: "",
  bumonNmTo: "",
  shainCdFrom: "",
  shainNmFrom: "",
  shainCdTo: "",
  shainNmTo: "",
  juchudenpyoNoFrom: "",
  juchudenpyoNoTo: "",
  tokuiCdFrom: "",
  tokuishitenCdFrom: "",
  tokuiNmFrom: "",
  tokuiCdTo: "",
  tokuishitenCdTo: "",
  tokuiNmTo: "",
  shokaKbn: getSCode(ShokaKbn, "0")!,
  sort1: getSCode(B010040Sort, "0")!,
  sort2: getSCode(B010040Sort, "1")!,
  sort3: getSCode(B010040Sort, "2")!,
  shodaibun: "",
  shochubun: "",
  shoshobun: "",
  hasoYmdFrom: startOfMonth(date()),
  hasoYmdTo: date(),
  b010040Status: getSCode(B010040Status, "1")!,
  assistantCd: "",
  assistantNm: "",
};

const focusId = "B010040";

export const B010040 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス関数
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移
  const navigate = useNavigate();

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  //Excel出力ボタンクリックイベント
  const handleClickExcelButton = () => {
    // Excel出力フォームのデータを取得する。
    const fields = methods.getValues();

    // 消化区分
    let paramShokaKbn;
    if (fields.shokaKbn?.value! === "0") {
      paramShokaKbn = undefined;
    } else if (fields.shokaKbn?.value! === "1") {
      paramShokaKbn = shokaKbn.normal;
    } else if (fields.shokaKbn?.value! === "2") {
      paramShokaKbn = shokaKbn.shoka;
    }

    // 出力順の値に応じたソート処理
    let order1: string[] = ["", "", ""];
    if (fields.sort1?.value === "0") {
      order1 = ["juchuYmd,asc", "", ""];
    } else if (fields.sort1?.value === "1") {
      order1 = ["juchudenpyoNo,asc", "juchugyoNo,asc", "juchukoseigyoNo,asc"];
    } else if (fields.sort1?.value === "2") {
      order1 = ["tokuiCd,asc", "tokuishitenCd,asc", ""];
    } else if (fields.sort1?.value === "3") {
      order1 = ["shainCd,asc", "", ""];
    }

    let order2: string[] = ["", "", ""];
    if (fields.sort2?.value === "0") {
      order2 = ["juchuYmd,asc", "", ""];
    } else if (fields.sort2?.value === "1") {
      order2 = ["juchudenpyoNo,asc", "juchugyoNo,asc", "juchukoseigyoNo,asc"];
    } else if (fields.sort2?.value === "2") {
      order2 = ["tokuiCd,asc", "tokuishitenCd,asc", ""];
    } else if (fields.sort2?.value === "3") {
      order2 = ["shainCd,asc", "", ""];
    }

    let order3: string[] = ["", "", ""];
    if (fields.sort3?.value === "0") {
      order3 = ["juchuYmd,asc", "", ""];
    } else if (fields.sort3?.value === "1") {
      order3 = ["juchudenpyoNo,asc", "juchugyoNo,asc", "juchukoseigyoNo,asc"];
    } else if (fields.sort3?.value === "2") {
      order3 = ["tokuiCd,asc", "tokuishitenCd,asc", ""];
    } else if (fields.sort3?.value === "3") {
      order3 = ["shainCd,asc", "", ""];
    }

    // Excel出力パラメータを作成する。
    const param: B010040Request = {
      juchuYmdFrom: fields.juchuYmdFrom,
      juchuYmdTo: fields.juchuYmdTo,
      seisakuYmdFrom: fields.seisakuYmdFrom,
      seisakuYmdTo: fields.seisakuYmdTo,
      eigyoCdFrom: fields.eigyoCdFrom,
      eigyoCdTo: fields.eigyoCdTo,
      bumonCdFrom: fields.bumonCdFrom,
      bumonCdTo: fields.bumonCdTo,
      shainCdFrom: fields.shainCdFrom,
      shainCdTo: fields.shainCdTo,
      juchudenpyoNoFrom: fields.juchudenpyoNoFrom,
      juchudenpyoNoTo: fields.juchudenpyoNoTo,
      tokuiCdFrom: fields.tokuiCdFrom,
      tokuishitenCdFrom: fields.tokuishitenCdFrom,
      tokuiCdTo: fields.tokuiCdTo,
      tokuishitenCdTo: fields.tokuishitenCdTo,
      shokaKbn: paramShokaKbn,
      hasoYmdFrom: fields.hasoYmdFrom,
      hasoYmdTo: fields.hasoYmdTo,
      b010040Status: fields.b010040Status?.value,
      assistantCd: fields.assistantCd,
      sort: [
        order1[0],
        order1[1],
        order1[2],
        order2[0],
        order2[1],
        order2[2],
        order3[0],
        order3[1],
        order3[2],
        "juchudenpyoNo,asc",
        "juchugyoNo,asc",
        "juchukoseigyoNo,asc",
      ],
      shodaibun: fields.shodaibun,
      shochubun: fields.shochubun,
      shoshobun: fields.shoshobun,
    };
    B010040GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B010040_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
    //受注日の範囲(開始)にフォーカス
    focus(1);
  };

  //商品中分類が入力されているかどうか
  const existShochubun: boolean = methods.watch("shochubun") !== "";
  //商品中分類が入力されているかどうか
  const existShoshobun: boolean = methods.watch("shoshobun") !== "";

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="受注チェックリスト"
        gridTemplateColumns="7rem 3rem 3rem 5rem 1rem 10rem 1rem 6rem 5rem 9rem 6rem"
      >
        <SLabel>受注日</SLabel>
        <SDateField name="juchuYmdFrom" {...register(1)} gridColumn="span 3" />
        <SText>～</SText>
        <SDateField name="juchuYmdTo" {...register(2)} />

        <SLabel gridColumn="1">製作日</SLabel>
        <SDateField
          name="seisakuYmdFrom"
          {...register(3)}
          gridColumn="span 3"
        />
        <SText>～</SText>
        <SDateField name="seisakuYmdTo" {...register(4)} />

        <SLabel gridColumn="1">発送日</SLabel>
        <SDateField name="hasoYmdFrom" {...register(5)} gridColumn="span 3" />
        <SText>～</SText>
        <SDateField name="hasoYmdTo" {...register(6)} />

        <SLabel gridColumn="1">営業所</SLabel>
        <SNumberField
          name="eigyoCdFrom"
          code
          size={6}
          {...register(7)}
          gridColumn="span 3"
          onBlur={() => B000120EigyoNmFrom(methods, navigate, setMsg)}
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCdFrom", data.eigyoCd);
            methods.setValue("eigyoNmFrom", data.eigyoNmr);
          }}
        />
        <STextField name="eigyoNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="eigyoCdTo"
          code
          size={6}
          {...register(8)}
          gridColumn="span 2"
          onBlur={() => B000120EigyoNmTo(methods, navigate, setMsg)}
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCdTo", data.eigyoCd);
            methods.setValue("eigyoNmTo", data.eigyoNmr);
          }}
        />
        <STextField name="eigyoNmTo" size={40} disabled />
        <SLabel gridColumn="1">受注担当部門</SLabel>
        <SNumberField
          name="bumonCdFrom"
          code
          size={6}
          {...register(9)}
          onBlur={() => B000130BumonNmFrom(methods, navigate, setMsg)}
          gridColumn="span 3"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
            methods.setValue("bumonNmFrom", data.bumonNmr);
          }}
        />
        <STextField name="bumonNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="bumonCdTo"
          code
          size={6}
          {...register(10)}
          onBlur={() => B000130BumonNmTo(methods, navigate, setMsg)}
          gridColumn="span 2"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
            methods.setValue("bumonNmTo", data.bumonNmr);
          }}
        />
        <STextField name="bumonNmTo" size={40} disabled />
        <SLabel gridColumn="1">受注担当者</SLabel>
        <SNumberField
          name="shainCdFrom"
          code
          size={7}
          {...register(11)}
          onBlur={() => B000140ShainNmFrom(methods, navigate, setMsg)}
          gridColumn="span 3"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
            methods.setValue("shainNmFrom", data.shainNm);
          }}
        />
        <STextField name="shainNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="shainCdTo"
          code
          size={7}
          {...register(12)}
          onBlur={() => B000140ShainNmTo(methods, navigate, setMsg)}
          gridColumn="span 2"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
            methods.setValue("shainNmTo", data.shainNm);
          }}
        />
        <STextField name="shainNmTo" size={40} disabled />
        <SLabel gridColumn="1">受注No</SLabel>
        <SNumberField
          name="juchudenpyoNoFrom"
          code
          size={10}
          {...register(13)}
          gridColumn="span 3"
        />
        <SText>～</SText>
        <SNumberField name="juchudenpyoNoTo" code size={10} {...register(14)} />
        <SLabel gridColumn="1">得意先</SLabel>
        <SNumberField
          name="tokuiCdFrom"
          code
          size={6}
          {...register(15)}
          onBlur={() => B000150TokuiNmFrom(methods, navigate, setMsg)}
          gridColumn="span 2"
        />
        <SNumberField
          name="tokuishitenCdFrom"
          code
          size={4}
          {...register(16)}
          onBlur={() => B000150TokuiNmFrom(methods, navigate, setMsg)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdFrom", data.tokuiCd);
            methods.setValue("tokuishitenCdFrom", data.tokuishitenCd);
            methods.setValue("tokuiNmFrom", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="tokuiCdTo"
          code
          size={6}
          {...register(17)}
          onBlur={() => B000150TokuiNmTo(methods, navigate, setMsg)}
        />
        <SNumberField
          name="tokuishitenCdTo"
          code
          size={4}
          {...register(18)}
          onBlur={() => B000150TokuiNmTo(methods, navigate, setMsg)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdTo", data.tokuiCd);
            methods.setValue("tokuishitenCdTo", data.tokuishitenCd);
            methods.setValue("tokuiNmTo", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNmTo" size={40} disabled />
        <SLabel gridColumn={1}>消化区分</SLabel>
        <SCodeSelect
          name="shokaKbn"
          options={ShokaKbn}
          {...register(19)}
          gridColumn="span 3"
        />

        <SLabel gridColumn="1">商品分類</SLabel>
        <SNumberField
          name="shodaibun"
          label="商品大分類"
          code
          size={3}
          required={existShochubun}
          {...register(20)}
        />
        <SNumberField
          name="shochubun"
          label="商品中分類"
          required={existShoshobun}
          code
          size={3}
          {...register(21)}
        />
        <SNumberField
          name="shoshobun"
          label="商品小分類"
          code
          size={3}
          {...register(22)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            if (data.shochubun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", "");
              methods.setValue("shoshobun", "");
            } else if (data.shoshobun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", "");
            } else {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", data.shoshobun);
            }
          }}
        />

        <SLabel gridColumn="1">ステータス</SLabel>
        <SCodeSelect
          name="b010040Status"
          options={B010040Status}
          {...register(23)}
          gridColumn="span 3"
        />

        <SLabel gridColumn="1">アシスタント</SLabel>
        <SNumberField
          name="assistantCd"
          code
          size={7}
          {...register(24)}
          gridColumn="span 3"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("assistantCd", data.shainCd);
            methods.setValue("assistantNm", data.shainNm);
          }}
          onBlur={() => B000140AssistantNm(methods, navigate, setMsg)}
        />
        <STextField name="assistantNm" size={40} disabled gridColumn="span 2" />

        <SLabel gridColumn={1}>出力順</SLabel>
        <SCodeSelect
          name="sort1"
          options={B010040Sort}
          {...register(25)}
          gridColumn="span 3"
        />
        <SCodeSelect
          name="sort2"
          options={B010040Sort}
          {...register(26)}
          gridColumn="span 2"
        />
        <SCodeSelect
          name="sort3"
          options={B010040Sort}
          {...register(27)}
          gridColumn="span 3"
        />

        <SFileButton
          label={labels.buttons.excel}
          gridRow={13}
          gridColumn={11}
          {...register(28)}
          onClick={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
